<div class="modal-header">
    <h4 class="modal-title">{{ "extensionsOverview.modal.title" | translate }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
</div>

<div class="modal-body">
    @if (loading) {
        <p>{{ "extensionsOverview.modal.loading" | translate }}</p>
    } @else {
        @if (row.missing?.noContractDetails) {
            <div class="alert alert-warning">
                {{ "extensionsOverview.modal.noContractDetails" | translate }}
            </div>
        }

        @for (ed of editableDetails; track ed.detail.id) {
            <div class="detail-block mb-4">
                <h6 class="text-muted">
                    {{ "extensionsOverview.modal.detail" | translate }} #{{ ed.detail.id }}
                </h6>

                @if (isMissing(ed.missingFields, 'PO')) {
                    <div class="mb-2">
                        <label class="form-label small mb-1">{{ "extensionsOverview.field.PO" | translate }}</label>
                        <input type="text" class="form-control form-control-sm" [(ngModel)]="ed.detail.po">
                    </div>
                }
                @if (isMissing(ed.missingFields, 'CaseNumber')) {
                    <div class="mb-2">
                        <label class="form-label small mb-1">{{ "extensionsOverview.field.CaseNumber" | translate }}</label>
                        <input type="text" class="form-control form-control-sm" [(ngModel)]="ed.detail.caseNumber">
                    </div>
                }
                @if (isMissing(ed.missingFields, 'Budget')) {
                    <div class="mb-2">
                        <label class="form-label small mb-1">{{ "extensionsOverview.field.Budget" | translate }}</label>
                        <input type="text" class="form-control form-control-sm" [(ngModel)]="ed.detail.budget">
                    </div>
                }

                @if (ed.noItemNumbers) {
                    <div class="alert alert-warning py-1 px-2 small mb-2">
                        {{ "extensionsOverview.modal.noItemNumbers" | translate }}
                    </div>
                }

                @for (ei of ed.items; track ei.item.id) {
                    <div class="item-block ps-3 border-start mb-2">
                        <span class="small text-muted">
                            {{ "extensionsOverview.modal.item" | translate }} #{{ ei.item.id }}
                        </span>
                        @if (isMissing(ei.missingFields, 'Title')) {
                            <div class="mb-2">
                                <label class="form-label small mb-1">{{ "extensionsOverview.field.Title" | translate }}</label>
                                <input type="text" class="form-control form-control-sm" [(ngModel)]="ei.item.title">
                            </div>
                        }
                        @if (isMissing(ei.missingFields, 'Hours')) {
                            <div class="mb-2">
                                <label class="form-label small mb-1">{{ "extensionsOverview.field.Hours" | translate }}</label>
                                <input type="text" class="form-control form-control-sm" [(ngModel)]="ei.item.hours">
                            </div>
                        }
                    </div>
                }
            </div>
        }
    }
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">
        {{ "extensionsOverview.modal.close" | translate }}
    </button>
    @if (!loading && hasEditableFields) {
        <button type="button" class="btn btn-primary" [disabled]="saving" (click)="onSave()">
            {{ "extensionsOverview.modal.save" | translate }}
        </button>
    }
</div>
